// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import ErasShowSectionsNavController from "./eras/show/sections_nav_controller";
application.register("eras--show--sections-nav", ErasShowSectionsNavController);

import UserMenuController from "./user_menu_controller";
application.register("dropdown", UserMenuController);

import SegmentedDatePickerController from "./segmented_date_picker";
application.register("segmented-date-picker", SegmentedDatePickerController);

import MobilePlayerController from "./mobile_player_controller";
application.register("mobile-player", MobilePlayerController);

import SeekBarController from "./seek_bar_controller";
application.register("seek-bar", SeekBarController);

import VolumeController from "./volume_controller";
application.register("volume", VolumeController);
